module.exports = __webpack_public_path__ + "img/E-WEB-Goal-02.33218d41.svg";